<template>
  <section>
    <b-field>
      <b-upload
        v-model="file"
        accept="application/pdf"
        drag-drop
        expanded
        :disabled="uploadDisabled"
        @input="emitUpload($event)"
      >
        <section class="section is-medium">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"> </b-icon>
            </p>
            <b-progress
              v-if="uploadProgress"
              type="is-success"
              :value="uploadProgress"
              show-value
              format="percent"
            ></b-progress>
            <p v-else>
              PDF Datei per Drag & Drop oder Clicken hochladen
            </p>
          </div>
        </section>
      </b-upload>
    </b-field>
    <b-message type="is-warning" has-icon>
      <ul>
        <li>- Nur PDF-Dokumente mit Textinhalt werden unterstützt</li>
        <li>- Dokumente müssen eine nach dem anderem hochgeladen werden</li>
      </ul>
    </b-message>
  </section>
</template>

<script>
export default {
  props: {
    uploadProgress: { type: Number, required: false, default: null }
  },
  data() {
    return {
      file: null
    };
  },
  computed: {
    uploadDisabled() {
      return Boolean(this.uploadProgress);
    }
  },
  methods: {
    emitUpload(file) {
      this.$emit("upload", file);
    }
  }
};
</script>
